import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../css/sider.scss";

const SiderBar = ({ currentPage, setCurrentPage, isCollapsed }) => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState([]);

  const toggleMenu = (menu) => {
    if (expandedMenus.includes(menu)) {
      setExpandedMenus(expandedMenus.filter((m) => m !== menu));
    } else {
      setExpandedMenus([...expandedMenus, menu]);
    }
  };

  const menuItems = [
    {
      id: "home",
      label: "控制台",
      icon: "home",
      path: "/userAccount",
      hasSubmenu: false,
    },
    {
      id: "user-management",
      label: "用户管理",
      icon: "receive",
      path: "/user-management",
      hasSubmenu: false,
    },
    {
      id: "account-management",
      label: "账户管理",
      icon: "payment",
      path: "/my-account",
      hasSubmenu: false,
    },
    {
      id: "transaction",
      label: "交易管理",
      icon: "transaction",
      hasSubmenu: true,
      submenus: [
        {
          id: "incoming-orders",
          label: "入账订单",
          path: "/incoming-orders",
        },
      ],
    },
    {
      id: "message-center",
      label: "消息中心",
      icon: "settings",
      path: "/message-center",
      hasSubmenu: false,
    },
  ];

  const renderIcon = (iconType, isActive) => {
    const iconMap = {
      home: { normal: "/sider/s1-1.png", active: "/sider/s1-2.png" },
      receive: { normal: "/sider/s2-1.png", active: "/sider/s2-2.png" },
      payment: { normal: "/sider/s3-1.png", active: "/sider/s3-2.png" },
      transaction: { normal: "/sider/s4-1.png", active: "/sider/s4-2.png" },
      exchange: { normal: "/sider/s5-1.png", active: "/sider/s5-2.png" },
      domestic: { normal: "/sider/s6-1.png", active: "/sider/s6-2.png" },
      card: { normal: "/sider/s7-1.png", active: "/sider/s7-2.png" },
      settings: { normal: "/sider/s8-1.png", active: "/sider/s8-2.png" },
    };

    const iconSrc = isActive
      ? iconMap[iconType]?.active
      : iconMap[iconType]?.normal;

    return <img src={iconSrc} alt={iconType} className="menu-icon-img" />;
  };

  // 检查当前路径是否匹配菜单项
  const isMenuActive = (item) => {
    if (item.path) {
      return location.pathname === item.path;
    }
    if (item.submenus) {
      return item.submenus.some((sub) => location.pathname === sub.path);
    }
    return false;
  };

  // 当路由变化时，自动展开包含当前路由的菜单
  useEffect(() => {
    const menusToExpand = [];
    menuItems.forEach((item) => {
      if (item.hasSubmenu && item.submenus) {
        const hasActiveSubmenu = item.submenus.some(
          (sub) => location.pathname === sub.path
        );
        if (hasActiveSubmenu) {
          menusToExpand.push(item.id);
        }
      }
    });

    if (menusToExpand.length > 0) {
      setExpandedMenus((prev) => {
        const newExpanded = [...prev];
        menusToExpand.forEach((menuId) => {
          if (!newExpanded.includes(menuId)) {
            newExpanded.push(menuId);
          }
        });
        return newExpanded;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <aside className={`sidebar-container ${isCollapsed ? "collapsed" : ""}`}>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div key={item.id} className="menu-item-wrapper">
            {item.hasSubmenu ? (
              // 有子菜单的项目
              <div
                className={`menu-item ${isMenuActive(item) ? "active" : ""}`}
                onClick={() => toggleMenu(item.id)}
                title={isCollapsed ? item.label : ""}
              >
                <div className="menu-item-content">
                  <div className="menu-icon">
                    {renderIcon(item.icon, isMenuActive(item))}
                  </div>
                  <span className="menu-label">{item.label}</span>
                </div>
                <svg
                  className={`menu-arrow ${
                    expandedMenus.includes(item.id) ? "expanded" : ""
                  }`}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <path
                    d="M4 6l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ) : (
              // 没有子菜单的项目，使用 Link
              <Link
                to={item.path}
                className={`menu-item ${isMenuActive(item) ? "active" : ""}`}
                title={isCollapsed ? item.label : ""}
              >
                <div className="menu-item-content">
                  <div className="menu-icon">
                    {renderIcon(item.icon, isMenuActive(item))}
                  </div>
                  <span className="menu-label">{item.label}</span>
                </div>
              </Link>
            )}
            {item.hasSubmenu &&
              expandedMenus.includes(item.id) &&
              item.submenus && (
                <div className="submenu-container">
                  {item.submenus.map((submenu) => (
                    <Link
                      key={submenu.id}
                      to={submenu.path}
                      className={`submenu-item ${
                        location.pathname === submenu.path ? "active" : ""
                      }`}
                    >
                      {submenu.label}
                    </Link>
                  ))}
                </div>
              )}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default SiderBar;
